import api from "./index"

export async function getUsers({ offset = 0, limit = 10, search = "" } = {}) {
  const config = {
    params: { offset, limit, search },
  }
  return api.get("/v1/users", config)
}

export async function createUser(data) {
  return api.post("/v1/users", data)
}

export async function updateUser(userId, data) {
  return api.patch(`/v1/users/${userId}`, data)
}

export async function deleteUser(userId) {
  return api.delete(`/v1/users/${userId}`)
}
